import {Injectable} from '@angular/core';
import {Observable, Subject, debounceTime, distinctUntilChanged} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FilterService
{
    private readonly filterSubject$: Subject<string> = new Subject<string>();

    private filterKey = '';

    public changeFilter(filter: string): void
    {
        this.filterSubject$.next(filter);
        this.filterKey = filter;
    }

    public onFilterChanged(): Observable<string>
    {
        return this.filterSubject$.asObservable().pipe(distinctUntilChanged(), debounceTime(600));
    }

    public clearFilter(): void
    {
        this.filterSubject$.next('');
        this.filterKey = '';
    }

    public get filter(): string
    {
        return this.filterKey;
    }
}
